import { BuildModuleParamsType } from 'types/api-internal';
import { SugarMoneyApiSolPriceResponseType } from 'types/price';

export const priceModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  getSol: async () =>
    makeApiRequest<SugarMoneyApiSolPriceResponseType>({
      endpoint: 'price/sol',
      options: { method: 'get' },
    }),
});
